import { render } from "./BaseClosePopup.vue?vue&type=template&id=30af3b57&scoped=true"
import script from "./BaseClosePopup.vue?vue&type=script&lang=js"
export * from "./BaseClosePopup.vue?vue&type=script&lang=js"

import "./BaseClosePopup.vue?vue&type=style&index=0&id=30af3b57&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30af3b57"]])

export default __exports__